import { render, staticRenderFns } from "./mainRecommend.vue?vue&type=template&id=0a667c70"
import script from "./mainRecommend.vue?vue&type=script&lang=js"
export * from "./mainRecommend.vue?vue&type=script&lang=js"
import style0 from "./mainRecommend.vue?vue&type=style&index=0&id=0a667c70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports